import './component.scss'
import '../images/floating_footer_logo.svg'
import '../images/right_diagonal_upper_line.svg'
import '../images/right_diagonal_lower_line.svg'

const SCROLL_THRESHOLD = 300
const TRANSITION_DURATION = 600
const DISPLAY_DELAY = 20
const MAX_SP_WIDTH = 999

document.addEventListener('DOMContentLoaded', () => {
  const floatingElement = document.querySelector('.nurikae-site-subsidies-floating-cta-sp')
  if (!floatingElement) return

  const floatingState = {
    isVisible: false,
    isAnimating: false
  }

  const getFooterTop = () => {
    const footer = document.querySelector('footer') || document.querySelector('.footer')
    return footer ? footer.getBoundingClientRect().top + window.scrollY : Infinity
  }

  const isNearFooter = () => {
    const footerTop = getFooterTop()
    const windowBottom = window.scrollY + window.innerHeight
    return windowBottom >= footerTop
  }

  const handleScroll = () => {
    if (window.innerWidth > MAX_SP_WIDTH) {
      hideElementImmediately(floatingElement, floatingState)
      return
    }

    const shouldBeVisible = window.scrollY > SCROLL_THRESHOLD && !isNearFooter()

    if (shouldBeVisible === floatingState.isVisible || floatingState.isAnimating) return

    shouldBeVisible ? showElement(floatingElement, floatingState) : hideElement(floatingElement, floatingState)
  }

  const handleResize = () => {
    if (window.innerWidth >= MAX_SP_WIDTH) {
      hideElementImmediately(floatingElement, floatingState)
      return
    }

    if (window.scrollY > SCROLL_THRESHOLD && !isNearFooter() && !floatingState.isVisible && !floatingState.isAnimating) {
      showElement(floatingElement, floatingState)
    }
  }

  const initializeState = () => {
    if (window.innerWidth > MAX_SP_WIDTH || window.scrollY <= SCROLL_THRESHOLD || isNearFooter()) {
      floatingElement.style.display = 'none'
      return
    }

    floatingElement.style.display = 'block'
    floatingElement.style.opacity = '1'
    floatingState.isVisible = true
  }

  initializeState()
  window.addEventListener('scroll', handleScroll)
  window.addEventListener('resize', handleResize)
})

const showElement = (element, floatingState) => {
  if (floatingState.isAnimating || floatingState.isVisible) return

  floatingState.isAnimating = true
  element.style.display = 'block'

  setTimeout(() => {
    element.style.opacity = '1'

    setTimeout(() => {
      floatingState.isVisible = true
      floatingState.isAnimating = false
    }, TRANSITION_DURATION)
  }, DISPLAY_DELAY)
}

const hideElement = (element, floatingState) => {
  if (floatingState.isAnimating || !floatingState.isVisible) return

  floatingState.isAnimating = true
  element.style.opacity = '0'

  setTimeout(() => {
    element.style.display = 'none'
    floatingState.isVisible = false
    floatingState.isAnimating = false
  }, TRANSITION_DURATION)
}

const hideElementImmediately = (element, floatingState) => {
  if (element.style.display !== 'none') {
    element.style.opacity = '0'
    element.style.display = 'none'
    floatingState.isVisible = false
  }
}
